import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);
//获取原型对象上的push函数
const originalPush = Router.prototype.push;
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};



export default new Router({
  scrollBehavior(to, from, savedPosition) {
    return {x: 0, y: 0}
  },
  base: '/loanweb',
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: () => import('@/views/index.vue'),
      meta: {
        nav: '首页'
      }
    },
    {
      path: '/notice',
      name: 'notice',
      component: () => import('@/views/notice.vue'),
      meta: {
        nav: '采购公告'
      }
    }, {
      path: '/noticeDetail',
      name: 'noticeDetail',
      component: () => import('@/views/noticeDetail.vue'),
      meta: {
        nav: '采购公告详情'
      },
    },
    {
      path: '/news',
      name: 'news',
      component: () => import('@/views/news.vue'),
      meta: {
        nav: '新闻报道'
      }
    },
    {
      path: '/newsDetail',
      name: 'newsDetail',
      component: () => import('@/views/newsDetail.vue'),
      meta: {
        nav: '新闻报道详情'
      }
    },
    {
      path: '/product',
      name: 'product',
      component: () => import('@/views/product.vue'),
      meta: {
        nav: '融资超市'
      }
    },
    {
      path: '/productDetail',
      name: 'productDetail',
      component: () => import('@/views/productDetail.vue'),
      meta: {
        nav: '融资超市详情'
      }
    },
    {
      path: '/bankDetail',
      name: 'bankDetail',
      component: () => import('@/views/bankDetail.vue'),
      meta: {
        nav: '融资超市详情'
      }
    },
    {
      path: '/index',
      name: 'index',
      component: () => import('@/views/index.vue'),
      meta: {
        nav: '首页'
      }
    },
    {
      path: '/contract',
      name: 'contract',
      component: () => import('@/views/contract.vue'),
      meta: {
        nav: '采购合同'
      }
    },{
      path: '/contractDetail',
      name: 'contractDetail',
      component: () => import('@/views/contractDetail.vue'),
      meta: {
        nav: '采购合同详情'
      }
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js